import { Reveal, Eyebrow } from "./Reveal";
import {
  Wrench, Gem, Flame, Ruler, Sparkles, RefreshCw, PencilRuler, DraftingCompass,
  Layers, Diamond, Search, Watch, BatteryCharging, Sparkle, Clock3, ArrowRight,
} from "lucide-react";

const services = [
  { icon: Wrench, name: "Jewelry Repair" },
  { icon: Gem, name: "Diamond Setting" },
  { icon: Flame, name: "Soldering" },
  { icon: Ruler, name: "Sizing" },
  { icon: Sparkles, name: "Cleanings" },
  { icon: RefreshCw, name: "Reconditioning" },
  { icon: PencilRuler, name: "Custom Designs" },
  { icon: DraftingCompass, name: "CAD Designing" },
  { icon: Layers, name: "Custom Sets" },
  { icon: Diamond, name: "Loose Stones" },
  { icon: Search, name: "Branded Jewelry Sourcing" },
  { icon: Watch, name: "Watch Servicing" },
  { icon: BatteryCharging, name: "Battery Replacement" },
  { icon: Sparkle, name: "Polishing" },
  { icon: Clock3, name: "Crystal & Dial Replacement" },
];

export const Services = () => {
  return (
    <section id="services" data-testid="services-section" className="pt-4 pb-24 lg:pt-6 lg:pb-32">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <Reveal className="max-w-2xl">
          <Eyebrow>Services We Provide</Eyebrow>
          <h2 className="font-display text-4xl md:text-5xl font-light tracking-tight text-neutral-900" data-testid="services-heading">
            Expert service, <span className="text-[#C9A227]">from repair to custom design</span>
          </h2>
          <p className="mt-6 text-base md:text-lg leading-relaxed text-neutral-600">
            Bring your pieces to any showroom — handled quickly and
            with the same honesty we bring to every appraisal.
          </p>
        </Reveal>

        <div className="mt-14 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 lg:gap-5">
          {services.map(({ icon: Icon, name }, i) => (
            <Reveal key={name} delay={0.03 * i}>
              <div
                data-testid={`service-item-${name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                className="flex items-center gap-3 bg-white border border-[#E8DCC4] rounded-sm px-5 py-4 h-full hover:border-[#C9A227] hover:-translate-y-0.5 hover:shadow-[0_12px_30px_rgb(201,162,39,0.10)] transition-[border-color,transform,box-shadow] duration-300"
              >
                <Icon size={20} strokeWidth={1.25} className="text-[#C9A227] shrink-0" />
                <span className="text-sm font-semibold text-neutral-800">{name}</span>
              </div>
            </Reveal>
          ))}
          <Reveal delay={0.03 * services.length}>
            <a
              href="#contact"
              data-testid="service-item-and-more"
              className="flex items-center gap-3 bg-gradient-to-r from-[#E8CC6E] to-[#C9A227] rounded-sm px-5 py-4 h-full text-neutral-900 hover:-translate-y-0.5 transition-transform duration-300"
            >
              <ArrowRight size={20} strokeWidth={1.5} className="shrink-0" />
              <span className="text-sm font-semibold">...and more — just ask</span>
            </a>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
